// eslint-disable-next-line no-unused-vars
export default Object.freeze((..._args: unknown[]) => null);
